<template>
  <div>
    <h-select
      :items="timezones"
      label="Timezone"
      outline
      v-model="user.timezone"
      required
    ></h-select>
    <div class="outline">
      <label class="label" for="generate_exercises" @click="displayGenerateExercisesAt=true">
        What time would you like to receive your exercises?
      </label>
      <timepicker-modal
        @close="displayGenerateExercisesAt=false"
        :time="user.generate_exercises_at"
        @update="(time) => user.generate_exercises_at = time"/>
    </div>
    <div class="outline">
      <label for="generate_pulse_at" class="label" @click="displayGeneratePulseAt=true">
        What time would you like to receive your self-reflections?
      </label>
      <timepicker-modal
        :time="user.generate_pulse_at"
        @close="displayGeneratePulseAt=false"
        @update="(time) => user.generate_pulse_at = time"/>
    </div>
  </div>
</template>

<script>
import timezones from "./../timezones";
import timepickerModal from "./timepickerModal";

export default {
  props: ["user"],
  data() {
    return {
      timezones,
      displayGeneratePulseAt: false,
      displayGenerateExercisesAt: false
    };
  },
  methods: {
    convertTime(time) {
      if (!time) {
        return;
      }
      // eslint-disable-next-line
      let [hours, minutes, _] = time.split(":");
      let meridian = "AM";
      if (hours >= 12) {
        meridian = "PM";
        if (hours >= 13) {
          hours -= 12;
        }
      } else if (hours === "00") {
        hours = "12";
      }
      return `${hours}:${minutes} ${meridian}`;
    }
  },
  components: {
    timepickerModal
  }
};
</script>
